import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { UnleashProxyService } from '@shared/services/unleash-proxy.service';
import { selectMenus } from '@shared/store/selectors/menu.selector';
import { AppStates } from '@shared/store/state/app.state';
import { Subject, takeUntil } from 'rxjs';

import { MenuService } from './app.menu.service';
import { AppMenuitemComponent } from './app.menuitem.component';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
  imports: [NgIf, NgFor, AppMenuitemComponent, FormsModule, ReactiveFormsModule, CommonModule]
})
export class AppMenuComponent implements OnInit, OnDestroy {
  model: any[] = [];
  _model: any[] = [];
  menuActiveKey = null;

  public onComponentDestroy$ = new Subject<void>();
  constructor(
    public layoutService: LayoutService,
    public menuService: MenuService,
    private readonly store: Store<AppStates>,
    private unleashProxyService: UnleashProxyService
  ) {
    this.unleashProxyService.updateTrigger$.subscribe(() => {
      this.model = structuredClone(this._model);
      this.generateMenu();
    });
  }

  ngOnInit() {
    this.store
      .select(selectMenus)
      .pipe(takeUntil(this.onComponentDestroy$))
      .subscribe((menus) => {
        this.model = JSON.parse(JSON.stringify(menus));
        this._model = structuredClone(this.model);
        this.generateMenu();
      });
  }

  generateMenu() {
    this.model = this.model
      ?.map((item) => {
        if (!item || !Array.isArray(item.items)) {
          return { items: [item] };
        }

        const filteredSubmenus = item.items.filter((submenu) =>
          submenu.featureName ? this.unleashProxyService.isEnabled(submenu.featureName) : true
        );

        if (filteredSubmenus.length === 0) {
          return null;
        }
        return { items: [{ ...item, items: filteredSubmenus }] };
      })
      .filter((item): item is NonNullable<typeof item> => !!item);
  }

  ngOnDestroy(): void {
    this.onComponentDestroy$.next();
    this.onComponentDestroy$.complete();
  }
}
